
import { defineComponent, onMounted } from 'vue'
import { platform } from '@/api/tools'

export default defineComponent({
  name: 'AppModal',
  emits: ['update:modelValue'],
  props: {
    show: Boolean,
    modelValue: Boolean,
    closable: Boolean,
    wide: Boolean,
    overflow: Boolean
  },
  setup(props, { emit }) {    

    function close() {
      if (!props.show && props.closable) {
        emit('update:modelValue', false)
      } 
    }

    onMounted(() => {
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          close()
        }
      })
    })


    return { close, platform }
  }
})
